import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Kept out of badge.tsx so that file exports nothing but the component —
 * React Fast Refresh only preserves state for modules whose exports are all
 * components.
 *
 * Tinted background plus matching foreground rather than a solid fill: a table
 * of solid badges reads as a row of buttons and pulls focus from the data.
 * Semantic names (success/warning) not colour names, so a theme change cannot
 * leave "green" meaning "failed".
 */
export const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-secondary text-secondary-foreground',
        success: 'bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))]',
        warning: 'bg-[hsl(var(--warning)/0.14)] text-[hsl(var(--warning))]',
        danger: 'bg-destructive/10 text-destructive',
        info: 'bg-[hsl(var(--info)/0.12)] text-[hsl(var(--info))]',
        outline: 'border text-muted-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export type BadgeVariantProps = VariantProps<typeof badgeVariants>;
